export default __webpack_public_path__ + "static/media/sub-class2.0e1ee62e.svg";